// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__tH1xz","actions":"Footer_actions__CeGYY"};